import FileSaver from 'file-saver';
import type { ApiHook } from 'utils/request/useApi';

export const downloadConfig = async (
  api: ApiHook,
  type: 'startup' | 'current',
  blobKey: string,
): Promise<void> => {
  const { currentConfig, startupConfig } = await api.request({
    url: `/blobs/device-configuration/${blobKey}`,
    method: 'GET',
  });
  const blob = new Blob([type === 'current' ? currentConfig : startupConfig], {
    type: 'text/plain;charset=utf-8',
  });
  // !! DO NOT REUSE
  // Downloads should be handled by providing proper headers from backend and initiated using `<a href=""`
  // to use browser's native progress indication and avoid issues with large files.
  FileSaver.saveAs(blob, `${type}-${blobKey}.txt`); // !! DO NOT REUSE
};
